export default function NextChevron() {
  return (
    <svg
      width='27'
      height='11'
      viewBox='0 0 27 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0 1.5H24.5L16.5 9.5' stroke='#332819' strokeWidth='2' />
    </svg>
  );
}
